const isLocahost = false;
export default global.config = {    
    SiteName: "Indira Gandhi Delhi Technical University For Women",
    SiteTitle: "IGDTUW - Delhi",
    SiteDescription: "Indira Gandhi Delhi Technical University for Women",
    SiteKeyword: "IGDTUW,University in Delhi",
    uploadPath: isLocahost ? "https://www.igdtuw.ac.in/IGDTUW/uploads/" : "/IGDTUW/uploads/",
    API_URL: isLocahost ? "https://www.igdtuw.ac.in/igdtuw-api-1/api/v1/" : "/igdtuw-api-1/api/v1/",
    IsPrint: isLocahost ? true : false,
    reCAPTCHAkey: "6LeQWHAtAAAAAM79mez8W_a9-rMfAP-q2Pm0Vljt",
}

// http://localhost:8080/igdtuw-api-1/api/v1/test-mail?to={email}
// http://localhost:8080/igdtuw-api-1/api/v1/emails/preview